import React, { useContext, useMemo } from 'react';
import { GenericArea, SeatingViewerContext, isPlaceOccupied, SHAPE, ReverseRotate, } from '@wix/seating-common-components';
import classNames from 'classnames';
import { getVisualState } from '../../utils';
import s from './area.scss';
const ICON_SIZE = 18;
export const Area = ({ definition, definition: { categoryId, places, label, sectorLabel } }) => {
    const { onPlaceClick, placesStock, selectedPlaceIds, onPlaceMouseEnter, onPlaceMouseLeave, currentlyClickedPlaceId, mobile, shapeTypeConfig, } = useContext(SeatingViewerContext);
    const place = places[0];
    const placeId = place?.id;
    // FIXME: there's a bug on mobile for pricing options area when clicked - area doesn't become white (most likely because the id is different)
    const placeClicked = currentlyClickedPlaceId && currentlyClickedPlaceId === placeId;
    const occupied = isPlaceOccupied(place, placesStock);
    const selected = selectedPlaceIds.includes(placeId);
    const marked = occupied || placeClicked;
    const placeDetails = useMemo(() => ({ label, sectorLabel }), [label, sectorLabel]);
    const { perShapeConfig, visualStates } = shapeTypeConfig[SHAPE.AREA] ?? {};
    const shapeConfig = perShapeConfig?.[definition.id];
    const state = getVisualState({ selected, occupied });
    const { StatusComponent, wrapperStyle } = { ...visualStates?.[state], ...shapeConfig?.visualStates?.[state] };
    const handlePlaceClick = () => onPlaceClick?.({ place, categoryId });
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericArea, { className: classNames({
                [s.area]: !marked && !wrapperStyle,
                [s.markedArea]: marked && !wrapperStyle,
                [s.mobile]: mobile,
            }), labelClassName: s.label, definition: {
                ...definition,
                shapeColor: wrapperStyle?.fill ?? definition.shapeColor,
                shapeBorderColor: wrapperStyle?.stroke ?? definition.shapeBorderColor,
            }, dataHook: place?.id, cursor: wrapperStyle?.cursor ?? (occupied ? 'default' : 'pointer'), onClick: handlePlaceClick, onMouseEnter: onPlaceMouseEnter ? event => onPlaceMouseEnter({ event, place, categoryId, details: placeDetails }) : null, onMouseLeave: onPlaceMouseLeave ? event => onPlaceMouseLeave({ event, place, categoryId, details: placeDetails }) : null }),
        StatusComponent && (React.createElement("svg", { y: definition.height - ICON_SIZE },
            React.createElement(ReverseRotate, { rotateX: ICON_SIZE / 2, rotateY: ICON_SIZE / 2, angle: definition.angle, gProps: { pointerEvents: 'none' } },
                React.createElement(StatusComponent, { ticketColor: definition.shapeColor }))))));
};
//# sourceMappingURL=area.js.map